export default async function ({ $auth, $axios }) {
    if ($auth.loggedIn) {
        return
    }

    const token = await $axios.$get('/authenticate/token')
    if (!token) {
        return
    }

    $auth.setUserToken(token)
    window.location.replace('/')
}
